import axios from '@/core/axios'

import { ApiClientExtended } from './apiClientExtended'

// Connecting generated Api client to the existing axios instance.
export const Api = new ApiClientExtended({ instance: axios })
